module.exports = __webpack_public_path__ + "static/mosey-logo-b727c95762bddb64c3fed6e361ca5134.jpg";